<template>
  <section class="capabilities">
    <div class="capabilities__header">
      <span class="capabilities__label">{{ data.label }}</span>
      <h2 class="capabilities__title">{{ data.title }}</h2>
    </div>

    <div class="capabilities__cards">
      <CapabilityCard
        v-for="(card, index) in data.cards"
        :key="index"
        :title="card.title"
        :subtitle="card.description"
        :image="card.image"
        :bg-color="card.bgColor"
        :border-color="card.borderColor"
      />
    </div>

    <p class="capabilities__footer">{{ data.footer }}</p>
  </section>
</template>

<script>
import CapabilityCard from "./CapabilityCard.vue";

export default {
  name: "Capabilities",
  components: { CapabilityCard },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.capabilities {
  background-color: #f4f0e8;
  padding: 56px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  box-sizing: border-box;

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin-bottom: 20px;
  }

  &__label {
    font-family: $font-family;
    font-size: 12px;
    font-weight: normal;
    color: #8c6b2f;
    letter-spacing: 1.5px;
    text-align: center;
  }

  &__title {
    font-family: $font-family;
    font-size: 50px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    text-align: center;
  }

  &__cards {
    display: flex;
    gap: 18px;
    width: 100%;
  }

  &__footer {
    font-family: $font-family;
    font-size: 15px;
    font-weight: normal;
    color: #5f5a54;
    line-height: 1.76;
    text-align: center;
    margin: 0;
    max-width: 969px;
  }

  @include tablet {
    padding: 40px 32px;

    &__title {
      font-size: 40px;
    }
  }

  @include mobile {
    padding: 32px 20px;

    &__header {
      gap: 6px;
      margin-bottom: 10px;
    }

    &__label {
      font-size: 11px;
    }

    &__title {
      font-size: 30px;
    }

    &__cards {
      flex-direction: column;
      gap: 14px;
    }

    &__footer {
      font-size: 14px;
      max-width: 100%;
    }
  }
}
</style>
